"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var firestore_1 = require("firebase/firestore");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var pick_1 = __importDefault(require("lodash/pick"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var CCEmail_1 = __importDefault(require("./CCEmail"));
var MainContact_1 = __importDefault(require("./MainContact"));
var OutgoingName_1 = __importDefault(require("./OutgoingName"));
var EmailHeadersModal = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, setStep = _a.setStep, props = __rest(_a, ["open", "onClose", "setStep"]);
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var _c = __read((0, hooks_1.useSubmitter)('recharger_companies', rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id), 1), submitRechCompany = _c[0];
    var onSubmit = function (_a) {
        var contact = _a.contact, addContactInCc = _a.addContactInCc, extraFakeCcEmails = _a.extraFakeCcEmails, viaName = _a.viaName;
        return __awaiter(void 0, void 0, void 0, function () {
            var extraFakeCcEmailsToSubmit;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        extraFakeCcEmailsToSubmit = extraFakeCcEmails === null || extraFakeCcEmails === void 0 ? void 0 : extraFakeCcEmails.filter(function (ccContact) { return !(0, isEmpty_1.default)(ccContact); });
                        return [4 /*yield*/, submitRechCompany({
                                viaName: viaName,
                                contact: (0, isEmpty_1.default)(contact) ? (0, firestore_1.deleteField)() : contact,
                                addContactInCc: addContactInCc,
                                extraFakeCcEmails: (extraFakeCcEmailsToSubmit === null || extraFakeCcEmailsToSubmit === void 0 ? void 0 : extraFakeCcEmailsToSubmit.length) ? extraFakeCcEmailsToSubmit : (0, firestore_1.deleteField)(),
                            })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, (setStep === null || setStep === void 0 ? void 0 : setStep())];
                    case 2:
                        _b.sent();
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, __assign({ open: open, onClose: onClose }, props, { label: "Billing Method", PaperProps: { sx: { maxWidth: 660 } } }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit, initialValues: __assign(__assign({}, (0, pick_1.default)(rechargerCompany, ['viaName', 'contact', 'addContactInCc'])), { extraFakeCcEmails: (_b = rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.extraFakeCcEmails) !== null && _b !== void 0 ? _b : [{}] }) }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit, submitting = _a.submitting, valid = _a.valid;
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Email headers" })) }), (0, jsx_runtime_1.jsxs)(ModalContent_1.default, __assign({ maxHeight: 575 }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone" }, { children: "Here you can configure the header of outgoing emails to your customers." })), (0, jsx_runtime_1.jsx)(OutgoingName_1.default, {}), (0, jsx_runtime_1.jsx)(MainContact_1.default, {}), (0, jsx_runtime_1.jsx)(CCEmail_1.default, {}), (0, jsx_runtime_1.jsx)(Box_1.default, { pb: 5 })] })), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, __assign({ px: 5, py: 3 }, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "inline-flex", alignItems: "center", justifyContent: "flex-end", gap: 3 }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "neutral", onClick: onClose, size: "large" }, { children: "I'll do this later" })), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ isSending: submitting, disabled: !valid, size: "large", type: "submit", onClick: handleSubmit }, { children: "Submit" }))] })) }))] }));
            } })) })));
};
exports.default = EmailHeadersModal;
